export default {
  title: 'แจ้งซ่อม',
  new_request: 'แจ้งซ่อมใหม่',
  form_title: 'ส่งคำร้องแจ้งซ่อม',
  title_label: 'หัวข้อ',
  title_placeholder: 'อธิบายปัญหาโดยย่อ',
  category_label: 'ประเภท',
  category_note: 'รายละเอียดหมวดหมู่',
  category_note_placeholder: 'โปรดระบุประเภทปัญหาเพิ่มเติม',
  category_placeholder: 'เลือกประเภท',
  description_label: 'รายละเอียด',
  description_placeholder: 'อธิบายปัญหาโดยละเอียด',
  photo_label: 'รูปภาพ (ไม่บังคับ)',
  photo_upload_failed: 'อัปโหลดรูปไม่สำเร็จ กรุณาลองใหม่หรือลบรูปออก',
  take_photo: 'ถ่ายรูป',
  no_requests: 'ไม่มีคำร้องแจ้งซ่อม',
  submit_success: 'ส่งคำร้องสำเร็จ',
  no_active_lease: 'คุณต้องมีสัญญาเช่าที่ใช้งานอยู่เพื่อส่งคำร้อง',
}
